import React, { useEffect, useState } from 'react'
import useUserListingStyles from './styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import ClearIcon from '@mui/icons-material/Clear'
import VisibilityIcon from '@mui/icons-material/Visibility'
import EditIcon from '@mui/icons-material/Edit'
import { Grid, Typography, Divider, Box, TablePagination } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { useTheme } from '@mui/material/styles'
import {
  FetchUsersListNew,
  FetchPlantListNew,
  DeleteUserNew,
  RemovePlantToUserNew,
  AddPlantToUserNew,
  FetchRoles,
  FetchOrganizations
} from '../../services/api'
import AddExternalUserspage from '../Settings/components/AddExternalUserspage/AddExternalUserspage'
import Addplantimg from '../../assets/images/add1.svg'
import Deleteplantimg from '../../assets/images/delete1.svg'
import Button from '@mui/material/Button'
import dayjs from 'dayjs'
import PlantSelection from '../Settings/components/AddExternalUserspage/utils/PlantSelection'

const UserListing = ({ logic }) => {
  const classes = useUserListingStyles()

  const theme = useTheme()
  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  const [open, setOpen] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [email, setEmail] = React.useState('')
  const [deleteuserEmail, setDeleteuserEmail] = React.useState('')
  // allPlants holds the complete fetched list (across all pages)
  const [allPlants, setAllPlants] = useState([])
  // modalPlantList is the filtered list shown in the "Add Plant To User" dialog
  const [modalPlantList, setModalPlantList] = useState([])
  const { filterType, setters } = logic
  const { setFilterType } = setters
  const [usersList, setUsersList] = React.useState([])
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(10)
  const [totalCount, setTotalCount] = useState(0)

  const [userId, setUserId] = useState('')
  const [deleteuserId, setDeleteUserId] = useState('')
  const [deleteplantId, setDeletePlantId] = useState('')
  const [deleteplantUserId, setDeletePlantUserId] = useState('')
  const [deleteplantName, setDeletePlantName] = useState('')
  const [openDeletePlant, setOpenDeletePlant] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [plantIds, setPlantIds] = React.useState([])
  const [errors, setErrors] = useState({
    personName: '',
  })

  const [openView, setOpenView] = useState(false)
  const [selectedUserDetails, setSelectedUserDetails] = useState(null)
  const [rolesList, setRolesList] = useState([])
  const [orgList, setOrgList] = useState([])
  const [deleteUserName, setDeleteUserName] = useState('')

  const token = localStorage.getItem('accessToken')

  const fetchUsers = (type, p, l) => {
    // Fallback to state if arguments are not provided
    const targetPage = (p !== undefined ? p : page) + 1
    const targetLimit = l !== undefined ? l : limit
    const targetType = type !== undefined ? type : filterType

    FetchUsersListNew(token, targetType, targetPage, targetLimit).then((resp) => {
      if (resp?.data) {
        // Robust data extraction
        const data = resp.data.data || resp.data
        const users = data.users || (Array.isArray(data) ? data : [])
        const total = data.pagination.total || data.count || (Array.isArray(data.users) ? data.users.length : 0)

        setUsersList(users)
        setTotalCount(total)
      }
    })
  }

  useEffect(() => {
    fetchUsers(filterType, page, limit)

    FetchRoles(token).then(resp => {
      const roles = resp?.data?.roles || resp?.data?.data || []
      if (Array.isArray(roles)) setRolesList(roles)
    })
    FetchOrganizations(token).then(resp => {
      const orgs = resp?.data?.data || resp?.data?.organizations || []
      if (Array.isArray(orgs)) setOrgList(orgs)
    })
  }, [filterType, page, limit])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10))
    setPage(0)
  }

  // Fetch all plants (handles backend pagination) and keep a single master list
  useEffect(() => {
    const fetchAllPlants = async () => {
      try {
        const Order = '1'
        const limit = 100
        let offset = 0
        let aggregated = []
        while (true) {
          const resp = await FetchPlantListNew(
            dayjs().format('YYYY-MM-DD'),
            token,
            Order,
            limit,
            offset
          )
          const batch = resp?.data?.data || resp?.data?.plants || []
          aggregated = aggregated.concat(batch)
          // Stop if fewer than limit returned (last page) or no items
          if (batch.length < limit || batch.length === 0) break
          offset += batch.length
        }
        setAllPlants(aggregated)
      } catch (e) {
        console.error('Failed to fetch all plants', e)
      }
    }
    fetchAllPlants()
  }, [token])

  useEffect(() => {
    // Refresh full plant list whenever dialog actions may have changed assignments
    const refreshPlants = async () => {
      try {
        const Order = '1'
        const resp = await FetchPlantListNew(
          dayjs().format('YYYY-MM-DD'),
          token,
          Order,
          100,
          0
        )
        const initial = resp?.data?.data || resp?.data?.plants || []
        setAllPlants(initial)
      } catch (e) {
        console.error('Plant refresh failed', e)
      }
    }
    refreshPlants()
  }, [openDelete, openDeletePlant, token])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDeleteOpen = () => {
    setOpenDelete(true)
  }

  const handleDeleteClose = () => {
    setOpenDelete(false)
  }

  const handleOpenDeleteUser = (Data) => {
    setDeleteUserId(Data?.id || Data?._id || Data?.userId)
    setDeleteuserEmail(Data?.email)
    setDeleteUserName(Data?.name || `${Data?.firstName} ${Data?.lastName}`)
    handleDeleteOpen()
  }

  const handleDeleteUser = () => {
    DeleteUserNew(deleteuserId, token).then((resp) => {
      if (resp?.status === 200 || resp?.data) {
        setUsersList(prev => prev.filter(user => (user.id || user._id || user.userId) !== deleteuserId))
        handleDeleteClose()
      }
    })
  }

  const getFilteredPlantList = (userData) => {
    const assignedPlantIds = userData?.plants?.map((plant) => plant.id) || userData?.assignedPlantIds || []
    return allPlants.filter((plant) => !assignedPlantIds.includes(plant.id))
  }

  const handleAddplant = (Data) => {
    setUserId(Data?.userId)
    setEmail(Data?.email)
    const availablePlants = getFilteredPlantList(Data)
    setModalPlantList(availablePlants)
    handleOpen()
  }

  const handleAddUser = () => {
    const Data = {
      userId: userId,
      plantIds: plantIds,
    }

    AddPlantToUserNew(Data, token).then((resp) => {
      if (resp?.data) {
        handleClose()
      } else {
      }
    })
  }

  const handleOpenView = (user) => {
    setSelectedUserDetails(user)
    setOpenView(true)
  }

  const handleEditUser = (user) => {
    if (logic) {
      logic.setters.setEditData(user)
      setOpenEdit(true)
    }
  }

  const handleEditClose = () => {
    setOpenEdit(false)
    if (logic) logic.setters.setEditData(null)
  }

  const getRoleName = (roleId) => {
    const role = rolesList.find(r => r.id === roleId || r._id === roleId)
    return role ? role.name : roleId
  }

  const getOrgName = (orgId) => {
    const org = orgList.find(o => o.id === orgId || o._id === orgId)
    return org ? org.organizationName : orgId
  }

  const handleChangePlantName = (event) => {
    const {
      target: { value },
    } = event
    setPlantIds(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    )
    setErrors({ ...errors, personName: '' })
  }

  const handleDeletePlant = () => {
    const PlantData = {
      userId: deleteplantUserId,
      plantIds: [deleteplantId],
    }
    RemovePlantToUserNew(PlantData, token).then((resp) => {
      if (resp?.data) {
        handleDeletePlantClose()
      } else {
      }
    })
  }

  const handleOpenDeletePlantFromUser = (Data, plant) => {
    setDeletePlantId(plant?.id)
    setDeletePlantUserId(Data?.userId)
    setDeletePlantName(plant?.plantName)
    handleDeletePlantOpen()
  }

  const handleDeletePlantOpen = () => {
    setOpenDeletePlant(!openDeletePlant)
  }

  const handleDeletePlantClose = () => {
    setOpenDeletePlant(!openDeletePlant)
  }

  const handleFilterChange = (event) => {
    setFilterType(event.target.value)
    setPage(0)
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <table className={classes.tableStyle}>
            <thead>
              <tr>
                <th className={classes.thStyle}>Name</th>
                <th className={classes.thStyle}>Email</th>
                <th className={classes.thStyle}>Type</th>
                <th className={classes.thStyle}>Plants</th>
                <th className={classes.thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {usersList?.map((Data) => (
                <tr key={Data.id || Data._id}>
                  <td className={classes.tdStyle}>{Data?.name || `${Data?.firstName} ${Data?.lastName}`}</td>
                  <td className={classes.tdStyle}>{Data?.email}</td>
                  <td className={classes.tdStyle}>
                    {Data?.metadata?.externalUserType
                      ? Data.metadata.externalUserType.charAt(0).toUpperCase() + Data.metadata.externalUserType.slice(1)
                      : Data?.userType.charAt(0).toUpperCase() + Data.userType.slice(1)}
                  </td>
                  <td className={classes.tdStyle}>
                    {Data?.plants?.length > 0
                      ? `${Data.plants.length} Plant${Data.plants.length > 1 ? 's' : ''}`
                      : '-'}
                  </td>
                  <td className={classes.tdStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                      <VisibilityIcon
                        sx={{ cursor: 'pointer', color: '#1976d2' }}
                        onClick={() => handleOpenView(Data)}
                      />
                      <EditIcon
                        sx={{ cursor: 'pointer', color: '#2e7d32' }}
                        onClick={() => handleEditUser(Data)}
                      />
                      <img
                        style={{
                          height: '20px',
                          width: '20px',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleOpenDeleteUser(Data)}
                        src={Deleteplantimg}
                        alt="Delete user icon"
                      />
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: 1 }}>
            <TablePagination
              component="div"
              count={Number(totalCount) || 0}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              sx={{
                '& .MuiTablePagination-toolbar': {
                  padding: 0,
                },
                '& .MuiTablePagination-selectLabel': {
                  marginBottom: 0,
                },
                '& .MuiTablePagination-displayedRows': {
                  marginBottom: 0,
                }
              }}
            />
          </Box>
        </Grid>
      </Grid>

      <Dialog
        className="businessview_dialog"
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="h_1">Add Plant To User</div>

            <DialogActions>
              <ClearIcon onClick={handleClose} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <PlantSelection
                personName={plantIds}
                handleChangePlantName={handleChangePlantName}
                plantList={modalPlantList}
                errors={errors}
                theme={theme}
                MenuProps={MenuProps}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div>{email}</div>
            </Grid>
          </Grid>

          <DialogActions>
            <button onClick={handleAddUser} className="save_btn">
              Save
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        className="Delete_dialog"
        open={openDelete}
        onClose={handleDeleteClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ p: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Confirm Deletion</Typography>
            <ClearIcon onClick={handleDeleteClose} sx={{ cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to delete the user <strong>{deleteUserName}</strong>?
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="subtitle2" color="textSecondary">Email</Typography>
              <Typography variant="body2">{deleteuserEmail}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle2" color="textSecondary">User ID</Typography>
              <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>{deleteuserId}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleDeleteClose} variant="outlined">Cancel</Button>
          <Button onClick={handleDeleteUser} variant="contained" color="error">
            Confirm Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Details Dialog */}
      <Dialog
        open={openView}
        onClose={() => setOpenView(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ p: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">User Details</Typography>
            <ClearIcon onClick={() => setOpenView(false)} sx={{ cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 3 }}>
          {selectedUserDetails && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Name</Typography>
                <Typography variant="body1">{selectedUserDetails?.name || `${selectedUserDetails?.firstName} ${selectedUserDetails?.lastName}`}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Email</Typography>
                <Typography variant="body1">{selectedUserDetails?.email}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Role</Typography>
                <Typography variant="body1">
                  {selectedUserDetails?.role?.name || (selectedUserDetails?.roles?.[0]?.name) || (selectedUserDetails?.metadata?.roleId ? getRoleName(selectedUserDetails.metadata.roleId) : (selectedUserDetails?.metadata?.externalUserType || 'N/A'))}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="subtitle2" color="textSecondary">Organization</Typography>
                <Typography variant="body1">
                  {selectedUserDetails?.organization?.name || (selectedUserDetails?.metadata?.organizationId ? getOrgName(selectedUserDetails.metadata.organizationId) : 'N/A')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="textSecondary">Associated Plants</Typography>
                <Typography variant="body1">
                  {selectedUserDetails?.plants && selectedUserDetails.plants.length > 0
                    ? selectedUserDetails.plants.map(p => p.name).join(', ')
                    : 'None'}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpenView(false)} variant="contained" color="primary">Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        className="Delete_dialog_"
        open={openDeletePlant}
        onClose={handleDeletePlantClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="h_1">
              {' '}
              Are you sure you want to delete this Plant?
            </div>
            <DialogActions>
              <ClearIcon onClick={handleDeletePlantClose} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Plant</div>
              <div>{deleteplantName}</div>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                User Id
              </div>
              <div>{deleteplantUserId}</div>
            </Grid>
          </Grid>

          <DialogActions>
            <Button onClick={handleDeleteClose}>Disagree</Button>
            <Button onClick={handleDeletePlant} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {/* Edit User Dialog */}
      <Dialog
        open={openEdit}
        onClose={handleEditClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ p: 2 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Edit User</Typography>
            <ClearIcon onClick={handleEditClose} sx={{ cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 3 }}>
          <AddExternalUserspage
            logic={logic}
            isModal={true}
            onClose={() => {
              handleEditClose();
              fetchUsers(filterType);
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  )
}

UserListing.propTypes = {}

export default UserListing
